import React from "react";
import ReactDOM from "react-dom";
import { HashRouter, Switch, Route } from "react-router-dom";
import "./CSS/landingPage.css";
import "./CSS/stage.scss";
import "./CSS/blog.scss";
import "./CSS/login.scss";
import "./CSS/admin.scss";
import "./CSS/tripDetail.scss";
import "./CSS/training.scss";
import "./CSS/trainingPlan.scss";
import "./CSS/connect.scss";
import "./CSS/planner.scss";
import "./CSS/places.scss";
import "./CSS/onboarding.scss";
import "./CSS/trainingInfo.scss";
import "./CSS/projectPage.css";
import "./CSS/index.css";
import LandingPage from "./PRESENTER/landingPage";
import ProjectPage from "./PRESENTER/projectPage";
import AboutMePage from "./PRESENTER/aboutMePage";
import WorkPage from "./PRESENTER/workPage";
import BlogPage from "./PRESENTER/blogPage";
import LoginPage from "./PRESENTER/loginPage";
import AdminPage from "./PRESENTER/adminPage";
import TripDetailPage from "./PRESENTER/tripDetailPage";
import TrainingPage from "./PRESENTER/trainingPage";
import TrainingPlanPage from "./PRESENTER/trainingPlanPage";
import TrainingHistoryPage from "./PRESENTER/trainingHistoryPage";
import ConnectPage from "./PRESENTER/connectPage";
import PlannerPage from "./PRESENTER/plannerPage";
import PlanDetailPage from "./PRESENTER/planDetailPage";
import PlacesPage from "./PRESENTER/placesPage";
import FoodPage from "./PRESENTER/foodPage";
import ProjektPage from "./PRESENTER/projektPage";
import BooksPage from "./PRESENTER/booksPage";
import BikesPage from "./PRESENTER/bikesPage";
import HemPage from "./PRESENTER/hemPage";
import TraderaPage from "./PRESENTER/traderaPage";
import RollerSkiPage from "./PRESENTER/rollerskiPage";
import LiftsPage from "./PRESENTER/liftsPage";
import SkiGamePage from "./PRESENTER/skiGamePage";
import MekPortalPage from "./PRESENTER/mekPortalPage";
import TodoPage from "./PRESENTER/todoPage";
import reportWebVitals from "./reportWebVitals";
import routeUrls from "./COMPONENTS/navbar/navLink";

ReactDOM.render(
  <React.StrictMode>
    <HashRouter>
      <Switch>
        <Route path={routeUrls.ADMIN}>
          <AdminPage />
        </Route>
        <Route path={routeUrls.LOGIN}>
          <LoginPage />
        </Route>
        <Route path={`${routeUrls.PLANNER}/:id`}>
          <PlanDetailPage />
        </Route>
        <Route path={routeUrls.PLANNER}>
          <PlannerPage />
        </Route>
        <Route path={routeUrls.PLACES}>
          <PlacesPage />
        </Route>
        <Route path={routeUrls.FOOD}>
          <FoodPage />
        </Route>
        <Route path={routeUrls.BOOKS}>
          <BooksPage />
        </Route>
        <Route path={routeUrls.BIKES}>
          <BikesPage />
        </Route>
        <Route path={routeUrls.HEM}>
          <HemPage />
        </Route>
        <Route path={routeUrls.TRADERA}>
          <TraderaPage />
        </Route>
        <Route path={routeUrls.ROLLERSKI}>
          <RollerSkiPage />
        </Route>
        <Route path={routeUrls.LIFTS}>
          <LiftsPage />
        </Route>
        <Route path={`${routeUrls.MEKPORTAL}/:topic?`}>
          <MekPortalPage />
        </Route>
        <Route path={routeUrls.SKIGAME}>
          <SkiGamePage />
        </Route>
        <Route path={routeUrls.TODO}>
          <TodoPage />
        </Route>
        <Route path={routeUrls.PROJEKT}>
          <ProjektPage />
        </Route>
        <Route path="/blogg/:id">
          <TripDetailPage />
        </Route>
        <Route path={routeUrls.BLOGG}>
          <BlogPage />
        </Route>
        <Route path={routeUrls.PROJECT}>
          <ProjectPage />
        </Route>
        <Route path={routeUrls.ABOUT}>
          <AboutMePage />
        </Route>
        <Route path={routeUrls.WORK}>
          <WorkPage />
        </Route>
        <Route path={routeUrls.CONNECT}>
          <ConnectPage />
        </Route>
        <Route path={routeUrls.TRAINING_HISTORY}>
          <TrainingHistoryPage />
        </Route>
        <Route path={routeUrls.TRAINING_PLAN}>
          <TrainingPlanPage />
        </Route>
        <Route path={routeUrls.TRAINING}>
          <TrainingPage />
        </Route>
        <Route path={routeUrls.HOME}>
          <LandingPage />
        </Route>
      </Switch>
    </HashRouter>
  </React.StrictMode>,
  document.getElementById("root")
);

reportWebVitals();
